var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"#F1F1F1"}},[_c('v-main',[_c('HelloWorld')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }